export type GenerativePlatformLibraryMode =
  | "image-generator"
  | "collection-build";

export const GENERATIVE_PLATFORM_LIBRARY_MODE_KEY =
  "ich_generative_platform_library_mode";

export const DEFAULT_GENERATIVE_PLATFORM_LIBRARY_MODE: GenerativePlatformLibraryMode =
  "collection-build";

export const GENERATIVE_PLATFORM_LIBRARY_TITLE = "Library";

export const GENERATIVE_PLATFORM_LIBRARY_MODE_LABEL: Record<
  GenerativePlatformLibraryMode,
  string
> = {
  "image-generator": "Image Generator",
  "collection-build": "Collection Build",
};

export const GENERATIVE_PLATFORM_LIBRARY_IMAGE_GENERATOR_INTRO =
  "Saved looks, design sheets, and templates from Image Generator.";

export const GENERATIVE_PLATFORM_LIBRARY_COLLECTION_BUILD_INTRO =
  "Browse your saved collection sessions and open any moodboard or look book to continue.";

export const IMAGE_GENERATOR_LIBRARY_HEADLINE =
  "Everything you've made, in one place.";

export const IMAGE_GENERATOR_LIBRARY_EMPTY_HINT =
  "Approve a look, save it to the library, or proceed to a design sheet to see it here.";

export const IMAGE_GENERATOR_LIBRARY_LOADING = "Loading saved templates…";

export const IMAGE_GENERATOR_LIBRARY_LOAD_ERROR =
  "Unable to load saved templates.";

export const IMAGE_GENERATOR_LIBRARY_RENAME_ERROR =
  "Unable to rename this library file.";

export const IMAGE_GENERATOR_LIBRARY_RENAME_SUCCESS = "Library name updated.";

export const IMAGE_GENERATOR_LIBRARY_TRY_AGAIN = "Try again";

export const IMAGE_GENERATOR_LIBRARY_NO_IMAGE = "No image";

export const COLLECTION_BUILD_LIBRARY_HEADLINE =
  "Everything you've made, in one place.";

export const COLLECTION_BUILD_LIBRARY_EMPTY_HINT =
  "Moodboards and look books you generate will show up here as collection sessions.";

export const COLLECTION_BUILD_LIBRARY_GENERATING = "Generating…";

export const COLLECTION_BUILD_LIBRARY_MOODBOARD_LABEL = "Moodboard";

/** Library cards need a real generated image — not drafts, failed, or in-flight placeholders. */
export const hasCollectionBuildLibraryImageUrl = (
  url: string | null | undefined
): url is string => {
  const trimmed = (url || "").trim();
  return Boolean(trimmed) && trimmed !== "null" && trimmed !== "undefined";
};

export const isGenerativePlatformLibraryMode = (
  value: string | null | undefined
): value is GenerativePlatformLibraryMode =>
  value === "image-generator" || value === "collection-build";
